module.exports = __webpack_public_path__ + "static/media/giphoto.8319eed7.jpg";